(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/draws.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/draws.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$numbergames$prod = svs.numbergames.productMapping,
  isSameProduct = _svs$numbergames$prod.isSameProduct,
  getProductItsId = _svs$numbergames$prod.getProductItsId,
  getProductDrawId = _svs$numbergames$prod.getProductDrawId;
const drawsApi = svs.numbergames.draws.drawsApi;

class Draws {
  constructor(_ref) {
    let productItsIds = _ref.productItsIds;
    this.productItsIds = productItsIds;
    productItsIds.forEach(id => {
      this[id] = new svs.numbergames.draws.Draw({
        productDrawId: getProductDrawId(id)
      });
    });
  }
  get isOpen() {
    return this.productItsIds.some(productItsId => this[productItsId].isOpen);
  }
  isProductOpen(product) {
    var _this$getProductItsId;
    return (_this$getProductItsId = this[getProductItsId(product)]) === null || _this$getProductItsId === void 0 ? void 0 : _this$getProductItsId.isOpen;
  }
  get isJokerOpen() {
    return this.productItsIds.some(productItsId => this[productItsId].isJokerOpen);
  }
  get upcomingDrawProduct() {
    const index = dateFns.closestIndexTo(drawsApi.clientNow(), this.productItsIds.map(id => new Date(this[id].firstDrawDate)));
    return this.productItsIds[index];
  }
  get wasOpenedToday() {
    return this.productItsIds.find(productItsId => this[productItsId].wasOpenedToday) || false;
  }
  firstAndLastDrawDates(_ref2) {
    var _this$productItsId$fi, _this$productItsId;
    let drawCount = _ref2.drawCount,
      productItsId = _ref2.productItsId;
    return (_this$productItsId$fi = (_this$productItsId = this[productItsId]) === null || _this$productItsId === void 0 ? void 0 : _this$productItsId.firstAndLastDrawDates({
      drawCount
    })) !== null && _this$productItsId$fi !== void 0 ? _this$productItsId$fi : {};
  }
  drawDay(_ref3) {
    let drawCount = _ref3.drawCount,
      productItsId = _ref3.productItsId;
    return _objectSpread({
      productItsId,
      isOpen: this[productItsId].isOpen
    }, this.firstAndLastDrawDates({
      drawCount,
      productItsId
    }));
  }
  drawDays(drawCount) {
    return this.productItsIds.map(productItsId => this.drawDay({
      productItsId,
      drawCount
    }));
  }
  drawNumbers(productItsIds) {
    return productItsIds.map(productItsId => ({
      productItsId,
      drawNumber: this[productItsId].drawNumber
    }));
  }
  firstRegCloseProductOf(products) {
    return products.find(product => isSameProduct(product, this.upcomingDrawProduct));
  }
}
svs.numbergames.draws.Draws = Draws;

 })(window);